import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/layout/Navbar/Navbar';
import HomePage from './components/pages/Home/HomePage';
import Restaurants from './components/pages/Restaurants/Restaurants';
import About from './components/pages/About/About';
import Contact from './components/pages/Contact/Contact';
import Menu from './components/pages/Menu/Menu';  // Import Menu component
import Map from './components/pages/Map/Map'; // Import the Map component
import { NavbarProvider } from './contexts/NavbarContext'; // Import NavbarProvider
import { RestaurantsProvider } from './contexts/RestaurantsContext'; // Import RestaurantsProvider
import Footer from './components/layout/Footer/Footer'

function App() {
    return (
        <NavbarProvider>
            <RestaurantsProvider>
                <Navbar />
                <div className="container">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/restaurants/:restaurantId" element={<Restaurants />} />
                        <Route path="/restaurants/:restaurantName/menu" element={<Menu />} />  {/* New Route */}
                        <Route path="/restaurants/:restaurantName/map" element={<Map />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/restaurants/:restaurantName/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/restaurants/:restaurantName/contact" element={<Contact />} />
                        {/* <Route path="/restaurants/:restaurantId/about" element={<RestaurantAbout />} /> Add specific about route */}
                    </Routes>
                </div>
                <Footer />
                <Analytics />
            </RestaurantsProvider>
        </NavbarProvider>
    );
}

export default App;